import fieldOperationsRoutes from "./fieldos_routes";
import voiceRoutes from "./voice_routes";
import waccRoutes from "./wacc_routes";

const service = localStorage.getItem("laddar_service");

const routes = {
  field_os: fieldOperationsRoutes,
  voice: voiceRoutes,
  wacc: waccRoutes,
};

export default routes[service] || fieldOperationsRoutes;